import { Component } from '@angular/core'
import { FormFieldFactoryComponentAbstract } from '../../../../ui/form-factory/core/component/form-field-factory/form-field-factory.component-abstract'

@Component({
    selector: 'mga-form-factory-field-accountmanager-user-id',
    templateUrl: './form-factory-field-accountmanager-user-id.component.html',
    styleUrls: ['./form-factory-field-accountmanager-user-id.component.scss'],
})
export class FormFactoryFieldAccountmanagerUserIdComponent extends FormFieldFactoryComponentAbstract {}
